import requestLists from './requestLists'
import requestSingleList from './requestSingleList'

export default [
  ...requestLists,
  ...requestSingleList
]
